/**
 * Formats a status string by replacing underscores with spaces,
 * capitalizing each word, and fixing "In" casing (e.g., "in_progress" -> "In Progress")
 */
export function formatStatus(status: string): string {
  return status
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .replace(/\bIn\b/i, 'In')
}

/**
 * Formats an incident type by capitalizing the first letter and lowercasing the rest
 * (e.g., "DAMAGE" -> "Damage")
 */
export function formatIncidentType(type: string): string {
  return type.charAt(0) + type.slice(1).toLowerCase()
}
